import { getCaseData, hasNoPendingDelete } from 'app/infrastructure/ui/renderer/resolvers';
import { tableName } from 'app/area/case/case-data-model';
import { getPrimaryEntityId } from 'app/infrastructure/store/entity';
import { CaseState } from 'app/area/case/types-store';
import { InitialUiEngineProps } from 'app/infrastructure/ui/types-uischema';

export const pendingDeleteIds = (caseState: CaseState, uiEngineProps: InitialUiEngineProps) => ({
  pendingDeleteIds: 
    getCaseData(caseState, uiEngineProps, true)
    .filter(e => !hasNoPendingDelete(e))
});

interface ConnectedCasesPendingDeleteIdsProps extends InitialUiEngineProps {
  connectionTypeId?: number;
}

export const connectedCasesPendingDeleteIds = (caseState: CaseState, uiEngineProps: ConnectedCasesPendingDeleteIdsProps) => {
  const connectionTypeId = uiEngineProps.connectionTypeId || 
                           uiEngineProps.componentDescriptor.properties.connectionTypeId;

  return {
    connectedCasesPendingDeleteIds: pendingDeleteIds(caseState, uiEngineProps)
      .pendingDeleteIds
      .filter(e => 
        e.id.findIndex(i => !!i[tableName.connectedCases]) > -1 &&
        e.id.some(i => i[tableName.connectionTypes] === connectionTypeId)
      )
      .map(e => getPrimaryEntityId(e))
  };
};
